import { sanityClient } from "build/sanity";
import React, { useEffect, useState } from "react";
import { useSiteSnippets } from "context/site-settings";

// Components
import Hero from "components/hero";
import RichText from "components/rich-text";
import ImageBanner from "components/image-banner";
import ImageText from "components/image-text";
import USPS from "components/usps";
import StaticReviews from "components/static-reviews";
import ButtonsGrid from "components/buttons-grid";
import { verticalSpacing } from "utils/module-settings";
import FeaturedBlogs from "components/blog/featured-blogs";
import FeaturedCollection from "components/featured-collection";
import StoreReviews from "components/store-reviews";
import ContactForm from "components/contact-form";
import ProductFinder from "components/product-finder";
import CollectionDetails from "components/collection-details";
import VideoText from "components/video-text";
import Product from "components/product";
import CoversBookGuide from "components/covers-book-guide";
import VehicleStylesShowcase from "components/vehicle-styles-showcase";
import SmallRichText from "components/small-rich-text";
import CollectionSizeGuide from "components/collection-size-guide";
import GenericTable from "components/generic-table";
import GenericIframe from "components/generic-iframe";
import RichTextLP from "components/rich-text-lp";
import PatioLinks from "components/patio-links";
import TarpProductBlocks from "components/tarp-product-blocks";
import ImageGridWithHeader from "components/image-grid-wHeader";
import CustomHtmlCode from "components/custom-html-code";
import IsolatedHtml from "components/isolated-html";
import PatioBreadcrumbs from "components/patio-breadcrumbs";
import ProductCreator from "components/product-creator";
import ProductFindBySize from "components/product-find-by-size";
import Breadcrumbs from "@_modules/breadcrumbs";
import CategoryGrid from "@_modules/category-grid";
import Tabs from "@_modules/tabs";
import AccordionProductLayout from "@_modules/accordion-product-layout";
import CTA from "@_modules/cta";
import ImageBannerSearch from "components/image-banner-search";
import ymmSection from "@_modules/ymm-section";
import MediaBlock from "components/media-block";
import GridBlock from "components/grid-block";
import AccordionBlock from "components/accordion-block";
import TablesBlock from "components/tables-block";
import RichTextNew from "components/rich-text-new";
import IndexedListBlock from "components/indexed-list-block";
import ButtonsList from "components/buttons-list";
import HorizontalDivider from "components/horizontal-divider";
import TrustedByBlock from "components/trusted-by-block";
import TopBanner from "components/top-banner";
import InfluencersVideoGrid from "components/influencers-video-grid";
import ReviewCards from "components/review-cards";
import ImageBlock from "components/image-block";
const _module2Component = {
    ymmSection: ymmSection,
    hero: Hero,
    richText: RichText,
    imageBanner: ImageBanner,
    imageText: ImageText,
    usps: USPS,
    staticReviews: StaticReviews,
    featuredBlogs: FeaturedBlogs,
    buttonsGrid: ButtonsGrid,
    featuredCollection: FeaturedCollection,
    iframe: GenericIframe,
    storeReviews: StoreReviews,
    contactForm: ContactForm,
    productFinder: ProductFinder,
    collectionDetails: CollectionDetails,
    videoWithText: VideoText,
    productsData: Product,
    coversBookGuide: CoversBookGuide,
    vehicleStylesShowcase: VehicleStylesShowcase,
    collectionSizeGuide: CollectionSizeGuide,
    imageBlock: ImageBlock,
    smallRichText: SmallRichText,
    genericTable: GenericTable,
    richTextLP: RichTextLP,
    patioLinks: PatioLinks,
    productBlocks: TarpProductBlocks,
    imageGridWithHeader: ImageGridWithHeader,
    customHtmlCode: CustomHtmlCode,
    isolatedHtml: IsolatedHtml,
    patioBreadcrumbs: PatioBreadcrumbs,
    productCreator: ProductCreator,
    productFindBySize: ProductFindBySize,
    breadcrumbs: Breadcrumbs,
    categoryGrid: CategoryGrid,
    tabs: Tabs,
    accordionProductLayout: AccordionProductLayout,
    imageBannerSearch: ImageBannerSearch,
    cta: CTA,
    mediaBlock: MediaBlock,
    accordion: AccordionBlock,
    gridBlock: GridBlock,
    tablesBlock: TablesBlock,
    richTextNew: RichTextNew,
    indexedListBlock: IndexedListBlock,
    buttonsList: ButtonsList,
    horizontalDivider: HorizontalDivider,
    trustedByBlock: TrustedByBlock,
    topBanner: TopBanner,
    influencersVideoGrid: InfluencersVideoGrid,
    reviewCards: ReviewCards,
};

const Module = ({ moduleData, type, pageHasH1 }) => {
    const snippets = useSiteSnippets();
    const matchedSnippet = snippets?.find((snippet) => snippet._id === moduleData?.snippet?._ref);
    const snippetModules = matchedSnippet?.module ?? [];

    const requestModule = (_data, _type) => {
        const RequestedModule = _module2Component[_type];
        // eslint-disable-next-line id-length
        const { id, verticalSpace } = _data?.moduleSettings ?? {};

        if (RequestedModule) {
            const data = _type === "productFinder" ? { ..._data, pageHasH1 } : _data;

            return (
                <section className={verticalSpace ? verticalSpacing(verticalSpace) : null} id={id}>
                    <RequestedModule data={data} />
                </section>
            );
        }
        return (
            <div />
        );
    };

    if (snippetModules?.length > 0) {
        return (
            <>
                {snippetModules.map((module) => {
                    const moduleType = module._type;
                    return requestModule(module, moduleType);
                })}
            </>
        );
    }
    if (moduleData._type) {
        return requestModule(moduleData, type);
    }
    return (
        <div />
    );
};

export default Module;
